export class ProposalBid {
    id!: string
    job!: string
    ownerId!: number
    bidTypeId!: string
    countyId!: string
}
